/** Entry point of the phase-D classroom package: registers objects, talk, drawers and day hooks. Imported once from main.ts. */
import { m } from '../i18n';
import { registerMenuItem } from './registry';
import { initClassroom, debugCase } from './classroom';
import { initSchoolEvents, debugEvent } from './schoolEvents';
import { openJournal } from '../ui/journal';
import '../render/propsClassroom';

initClassroom();
initSchoolEvents();
registerMenuItem(() => m().classroom.ui.journalMenu, () => openJournal());

// Debug hooks (`?debug`): window.__cls.case('late'), .event('contest'), .journal().
if (typeof window !== 'undefined' && /[?&]debug\b/.test(window.location.search)) {
  (window as unknown as { __cls: unknown }).__cls = { case: debugCase, event: debugEvent, journal: openJournal };
}
